import React, { useCallback, ReactElement } from 'react';
import Table from '../../../../components/table/table.component';
import TableBody from '../../../../components/table-body/table-body.component';
import TableRow from '../../../../components/table-row/table-row.component';
import TableCell from '../../../../components/table-cell/table-cell.component';
import FormFieldText from '../../../../components/form-field-text/form-field-text.component';
import ConnectorLinkBlock from '../../../../components/connector-link-block/connector-link-block.component';
import SinglePageTab from '../../../app/common/single-page-tab/single-page-tab.component';
import useScreenMobile from '../../../../hooks/use-screen-mobile';

const SettingsAccountYardi: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isSaving,
    isSaveDisabled,
    isEditMode,
    isRightDrawerOpen,
    formError,
    accountData,
    onCancelForm,
    onSubmitForm,
    onAssetConnectEmailClick,
  } = props;

  const isMobileScreen: boolean = useScreenMobile();

  const isEmpty: boolean = !accountData.yardiConnectorEmail && !isEditMode;
  const accountId: number | null = (accountData && accountData.id) || null;
  const formPrefix: string = 'account';

  const assetConnectEmailClick: Function = useCallback((): void => {
    if (onAssetConnectEmailClick) {
      onAssetConnectEmailClick(accountId);
    }
  }, [accountId]);

  return (
    <SinglePageTab
      isSaving={isSaving}
      isSaveDisabled={isSaveDisabled}
      isEditMode={isEditMode}
      isRightDrawerOpen={isRightDrawerOpen}
      isEmpty={isEmpty}
      formError={formError}
      onCancelForm={onCancelForm}
      onSubmitForm={onSubmitForm}
    >
      <Table>
        <TableBody isPlain withNoBorders withTwoColumns withHeaderColumn>
          {
            (accountData.yardiConnectorEmail || isEditMode) && (
              <TableRow>
                <TableCell>
                  Yardi Connector Email
                </TableCell>
                <TableCell>
                  {
                    isEditMode && (
                      <FormFieldText isBordered name={`${formPrefix}.yardiConnectorEmail`} />
                    )
                  }
                  {
                    !isEditMode && accountData.yardiConnectorEmail && (
                      <ConnectorLinkBlock
                        isEmail
                        isColumnView={isMobileScreen}
                        isConnected={accountData.isYardiConnectorEnabled}
                        link={accountData.yardiConnectorEmail}
                        onConnectClick={assetConnectEmailClick}
                      />
                    )
                  }
                </TableCell>
              </TableRow>
            )
          }
        </TableBody>
      </Table>
    </SinglePageTab>
  );
});

export default SettingsAccountYardi;
